var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"wordcloud","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }